import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/store/context";
import { Dropdown } from "bootstrap"; //important dont delete//
import QRCode from "react-qr-code";
import { _get } from "../../../apiClient.js";
import globals from "../../../globals.js";
import { IconLink, IconBrandWhatsapp, IconQrcode, IconShare, IconExternalLink } from '@tabler/icons-react'
import Demos from "./Demo.js";
import Icon from "@mdi/react";
import { mdiCartArrowUp } from "@mdi/js";
import StatisticsCard from "./StatisticsCard.js";
import MyQRCode from "./MyQrCode.js";
import SocialMedia from "./SocialMedia.js";
import CategoryWiseStatistics from "./CategoryWiseStatistics.js";
import InvitationActivity from "./InvitationActivity.js";
import { PopupButton } from "react-calendly";
import { formatBytes } from "../../utils/formatter.js";


export default function Dashboard() {
  const { logoutuser, showLoader, hideLoader, getToken, updateTitleAndIcon } = useAuth();
  const Navigate = useNavigate();
  const userDetails = useSelector((state) => state.admininfo.admininfo);
  const [totalEventCount, setTotalEventCount] = useState(0);
  const [allowableEventCount, setAllowableEventCount] = useState(0);
  const [activeEvents, setActiveEvents] = useState(0);
  const [packageName, setPackageName] = useState("");
  const [expiryOn, setExpiryOn] = useState("");
  const [percentage, setPercentage] = useState("0%");
  const [isExpired, setIsExpired] = useState(false);

  const [wedding, setWedding] = useState(0);
  const [birthday, setBirthday] = useState(0);
  const [ceremony, setCeremony] = useState(0);
  const [other, setOther] = useState(0);
  const [data, setData] = useState(null);


  const [totalDemoCount, setTotalDemoCount] = useState(0);
  const [allowableDemoCount, setAllowableDemoCount] = useState(0);
  const [activeDemos, setActiveDemos] = useState(0);
  const [demoPercentage, setDemoPercentage] = useState("0%");

  const [allowableImageCount, setAllowableImageCount] = useState(0);
  const [imageCount, setImageCount] = useState(0);
  const [imagePercentage, setImagePercentage] = useState("0%");

  const [allowableVideoCount, setAllowableVideoCount] = useState(0);
  const [videoCount, setVideoCount] = useState(0);
  const [videoPercentage, setVideoPercentage] = useState("0%");

  const [activeStorage, setActiveStorage] = useState(0);
  const [totalStorage, setTotalStorage] = useState(0);

  useEffect(() => {
    if (!getToken())
      logoutuser();
    updateTitleAndIcon(globals.dashboard.title, globals.dashboard.icon);
  }, []);

  useEffect(() => {
    if (userDetails) {
      getStatistics();
    }
  }, [userDetails]);

  const getStatistics = async () => {
    showLoader();
    await _get(`/statistics/dashboard`)
      .then(response => {
        setData(response);
        setTotalEventCount(response.totalEventCount);
        setAllowableEventCount(response.allowableEventCount);
        setPackageName(response.packageName);
        setExpiryOn(response.expiredOn);
        let activeCount = response.weddingCount + response.birthdayCount + response.ceremonyCount + response.otherCount;
        setPercentage(Math.round((1 - ((response.allowableEventCount - activeCount) / response.allowableEventCount)) * 100, 0) + "%");

        setActiveEvents(activeCount);
        setWedding(response.weddingCount);
        setBirthday(response.birthdayCount);
        setCeremony(response.ceremonyCount);
        setOther(response.otherCount);
        setIsExpired(response.isExpired);

        setTotalDemoCount(response.totalDemoCount);
        setAllowableDemoCount(response.allowableDemoCount);
        setActiveDemos(response.demoCount);
        setDemoPercentage(Math.round((1 - ((response.allowableDemoCount - response.demoCount) / response.allowableDemoCount)) * 100, 0) + "%");

        setAllowableImageCount(response.allowableImageCount);
        setImageCount(response.imageCount);
        setImagePercentage(Math.round((1 - ((response.allowableImageCount - response.imageCount) / response.allowableImageCount)) * 100, 0) + "%");

        setAllowableVideoCount(response.allowableVideoCount);
        setVideoCount(response.videoCount);
        setVideoPercentage(Math.round((1 - ((response.allowableVideoCount - response.videoCount) / response.allowableVideoCount)) * 100, 0) + "%");

        setActiveStorage(response.activeStorage);
        setTotalStorage(response.totalStorage);
        hideLoader();
      }).catch(error => {
        console.error("Error while fetching statistics:", error);
        hideLoader();
      });
  }


  return (
    <div className="content-wrapper">
      <div className="container-xxl flex-grow-1 container-p-y">
        {userDetails && (
          <div>
            <div style={{ marginBottom: '2.5rem' }}>
              <h5 className="card-title text-primary fs-13">
                Welcome, {userDetails.firstName} {userDetails.lastName}!
              </h5>
              <hr />
            </div>

            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-3 col-xl-2 mb-4">
                <div className="card  h-100">
                  <div className="card-body ">
                    <p className="mb-1 fs-10 uppercase fw-light">Summary</p>
                    <h5 className="card-title fs-15 mb-1">
                      Invitations
                    </h5>
                    <div className="mt-3">
                      <div className="d-flex gap-3 align-items-center">
                        <h2 className="mb-0">{totalEventCount}</h2><p className="mb-0">Invitations Created</p>
                      </div>
                      <div className="d-flex gap-3 align-items-center mt-3">
                        <h2 className="mb-0">{activeEvents}</h2><p className="mb-0">Active Invitations</p>
                      </div>
                      <div className="w-100 d-flex flex-column px-3 align-items-center">
                        <NavLink className="w-100 " to="/invitations">
                          <button className="btn btn-primary w-100 mt-3">Go To Invitations</button>
                        </NavLink>
                        <small className="mt-1 fs-11 fw-light">Manage invitations</small></div></div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-3 col-xl-2 mb-4">
                <div className="card  h-100">
                  <div className="card-body ">
                    <p className="mb-1 fs-10 uppercase fw-light">Summary</p>
                    <h5 className="card-title fs-15 mb-1">
                      Demos
                    </h5>
                    <div className="mt-3">
                      <div className="d-flex gap-3 align-items-center">
                        <h2 className="mb-0">{totalDemoCount}</h2><p className="mb-0">Demos Created</p>
                      </div>
                      <div className="d-flex gap-3 align-items-center mt-3">
                        <h2 className="mb-0">{activeDemos}</h2><p className="mb-0">Active Demos</p>
                      </div>
                      <div className="w-100 d-flex flex-column px-3 align-items-center">
                        <NavLink className="w-100 " to="/demos">
                          <button className="btn btn-primary w-100 mt-3">Go To Demos</button>
                        </NavLink>
                        <small className="mt-1 fs-11 fw-light">Manage demos</small></div></div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-lg-6 col-xl-3 mb-4 ">
                <div className="card h-100">
                  <div className="card-body">
                    <div className="App">
                      <p className="mb-1 fs-10 uppercase fw-light">Help</p>
                      <h5 className="card-title fs-15 mb-1">
                        Talk To Experts
                      </h5>
                      <p className="mt-1 fw-light">Book a session and Get a demo on how to use the application with full potential.</p>
                      <div className="mt-2 px-3 d-flex flex-column align-items-center">
                        <PopupButton
                          url="https://calendly.com/ajsinnovations/invitd-demo"
                          rootElement={document.getElementById("root")}
                          text="Schedule Now"
                          className="btn btn-primary w-100"
                        />
                        <div className="mt-3 text-center fw-light">write us at <a href="mailto:info@invitd.in">info@invitd.in</a> <br />
                          <div>+91 92462 98649</div>
                          <div>+91 79892 29018</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-8 col-lg-12 col-xl-5  mb-4">
                <div className="card h-100">
                  <div className="card-body">
                    <div>
                      <div className="d-flex flex-column justify-content-start align-items-start">
                        <div className="d-flex flex-row flex-grow-1 p-1  justify-content-center align-items-center flex-wrap">
                          <img src="/images/card-advance-sale.png" height="65px" />
                          <div className="d-flex flex-column justify-content-center align-items-start  mx-2 ">
                            <div className={"fs-10 uppercase " + (isExpired ? 'text-danger' : 'fw-light')}>
                              {isExpired ? "Expired" : "Active Plan"}
                            </div>
                            <h5 className="my-0 card-title fs-15 uppercase">{packageName}</h5>
                            <small className="fs-10">Valid Till: {expiryOn}</small>
                          </div>
                        </div>
                        <div className="d-flex w-100 mt-3 align-items-center gap-3">
                          <div className="flex-grow-1">
                            <small className="ms-1">Invitations</small>
                            <div className="progress progress-md mt-1 progress">
                              <div className="progress-bar" role="progressbar" aria-valuenow={percentage} aria-valuemin="0" aria-valuemax="100" style={{ width: percentage }}></div>
                            </div>
                            <div className="d-flex justify-content-between mt-1"><small>{activeEvents}</small><small>{allowableEventCount}</small></div>
                          </div>
                          <div className="mt-2">
                            <a className="w-100 " href="/plans">
                              <button className="btn btn-primary fs-11">
                                <span className="ms-1">Upgrade</span>
                                <Icon path={mdiCartArrowUp} size={"1.15rem"} className="ms-2" />
                              </button>
                            </a>
                          </div>
                        </div>
                        <div className="d-flex w-100 mt-3 align-items-center gap-3">
                          <div className="flex-grow-1">
                            <small className="ms-1">Demos</small>
                            <div className="progress progress-md mt-1 progress">
                              <div className="progress-bar" role="progressbar" aria-valuenow={demoPercentage} aria-valuemin="0" aria-valuemax="100" style={{ width: demoPercentage }}></div>
                            </div>
                            <div className="d-flex justify-content-between mt-1"><small>{activeDemos}</small><small>{allowableDemoCount}</small></div>
                          </div>
                          <div className="mt-2">
                            <a className="w-100 " href="/plans">
                              <button className="btn btn-primary fs-11">
                                <span className="ms-1">Upgrade</span>
                                <Icon path={mdiCartArrowUp} size={"1.15rem"} className="ms-2" />
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 mb-4">
                <div className="card h-100">
                  <div className="card-body">
                    <div>
                      <div className="d-flex flex-column justify-content-start align-items-start">
                        <div className="d-flex w-100  align-items-center gap-3">
                          <div className="flex-grow-1">
                            <small className="ms-1">Image Count</small>
                            <div className="progress progress-md mt-1 progress">
                              <div className="progress-bar" role="progressbar" aria-valuenow={imagePercentage} aria-valuemin="0" aria-valuemax="100" style={{ width: imagePercentage }}></div>
                            </div>
                            <div className="d-flex justify-content-between mt-1"><small>{imageCount}</small><small>{allowableImageCount}</small></div>
                          </div>
                        </div>
                        <div className="d-flex w-100 mt-3 align-items-center gap-3">
                          <div className="flex-grow-1">
                            <small className="ms-1">Video Count</small>
                            <div className="progress progress-md mt-1 progress">
                              <div className="progress-bar" role="progressbar" aria-valuenow={videoPercentage} aria-valuemin="0" aria-valuemax="100" style={{ width: videoPercentage }}></div>
                            </div>
                            <div className="d-flex justify-content-between mt-1"><small>{videoCount}</small><small>{allowableVideoCount}</small></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <div className="card h-100">
                  <div className="card-body">
                    <h5 className="card-title fs-15 mb-1">
                      Active Storage
                    </h5>
                    <div className="mt-3">
                      <h2 className="mb-0">{formatBytes(activeStorage)}</h2>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <div className="card h-100">
                  <div className="card-body">
                    <h5 className="card-title fs-15 mb-1">
                      Total Storage Consumed
                    </h5>
                    <div className="mt-3">
                      <h2 className="mb-0">{formatBytes(totalStorage)}</h2>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            {/* <CategoryWiseStatistics wedding={wedding} birthday={birthday} ceremony={ceremony} other={other} /> */}
            <InvitationActivity data={data} />
            <SocialMedia data={data} />
            {userDetails?.domain != "" && (
              <MyQRCode url={userDetails?.domain} />
            )}
            <Demos />
          </div>
        )}
      </div>
    </div>
  );
}
